// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for video filters
export const videoFilterState = $state({
    brightness: 100,
    contrast: 100,
    saturation: 100,
    invert: 0
});

// Reset all filters to default values
export function resetVideoFilters() {
    videoFilterState.brightness = 100;
    videoFilterState.contrast = 100;
    videoFilterState.saturation = 100;
    videoFilterState.invert = 0;
}